module.exports = __webpack_public_path__ + "static/media/managemed-logo-2.646121be.png";